export const Urls = {
    BaseURL: 'cdn-base-url',
    domain: 'https://bsw.paweb.org',

    programId: '57f0117e-a59d-42a3-b18a-b202011b0f00',
    
    // Page ids
    searchProfilePage: 323,
    homePage: 322,
    siteMap: 325,
    eLearning: 326,
    cvBuilder: 327,
    contentPage: 328,
    landingPage: 329,
    aboutPage: 331,
    infoForProvidersPage: 332,
    infoForEmployersPage: 333,
    registerPage: 334,
    privacyPolicyPage: 335,
    accessibilityPage: 336,
    termsPage: 337,
    directProviderReg: 334,
    directEmployerReg: 348,
    page_registrationLandingPage: 338,
    recruitingPersonalAssistantPage: 339,
    beingGoodEmployerPage: 340,
    contingenciesPage: 341,
    peerSupportPage: 342,
    dealingPage: 343,
    contactDetailsPage: 344,
    selfEmployedPersonalAssistantPage: 345,
    supportForPersonalAssistantPage: 346,

    
    // Form ids
  
}